import React from 'react';
import css from './css.module.less';

const Tip = (props) => {
  const { children } = props;
  return <div className={css.tipContainer}>{children}</div>;
};
export default Tip;
